// 1. React and DOM imports

// 2. External libraries
import { useQuery } from '@tanstack/react-query';

// 3. Internal components

// 4. Type imports
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import type { ConnectionResponse } from '~/generated/api/model';

// 5. Custom hooks and utilities
import { getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet } from '~/generated/api/connections/connections';
import { queryKeys } from './queryKeys';

/**
 * Query hook for fetching a single connection by ID.
 */
export function useConnectionQuery(
  topicId: string | undefined,
  connectionId: string | undefined,
  options?: Partial<UseQueryOptions<ConnectionResponse, Error>>
): UseQueryResult<ConnectionResponse, Error> {
  return useQuery<ConnectionResponse, Error>({
    queryKey: queryKeys.connection(topicId, connectionId),
    queryFn: async () => {
      if (!topicId || !connectionId) {
        throw new Error('Topic ID and Connection ID are required');
      }
      return getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet(topicId, connectionId);
    },
    enabled: !!topicId && !!connectionId,
    ...options,
  });
}
